function SummaryItem({ pRef, children }) {
  return (
    <a
      className="flex flex-row gap-0.5 md:justify-start justify-between cursor-pointer items-center"
      href={`#${pRef}`}
    >
      <div className="md:w-auto w-[262px]">{children}</div>
      <div>
        <img src="/icons/FAQ/Arrowbottom.svg" alt="arrow icon" />
      </div>
    </a>
  );
}

export default SummaryItem;
